// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content--1yqXirbk {\n  margin: 16px 0 8px;\n  max-height: 264px;\n  overflow-x: hidden;\n}\n.footer--29p9OAZ2 {\n  margin: 0 -16px -12px;\n  padding: 8px 8px 8px 2px;\n  background-color: #f3f4f7;\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n.noData--1CGLsdLm {\n  text-align: center;\n  color: #595959;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": "content--1yqXirbk",
	"footer": "footer--29p9OAZ2",
	"noData": "noData--1CGLsdLm"
};
export default ___CSS_LOADER_EXPORT___;
